<template>
  <!-- Komponent ze szczegółami pojazdu.
       Przekazuje do VehicleDetails informację, czy licznik czasu ma być widoczny (timer-visible).
       Dane pojazdu komponent pobiera sam: najpierw z listy pomiarów w store (natychmiastowy render),
       a następnie odświeża je odpowiedzią z API. -->
  <VehicleDetails :timer-visible="$route.meta.timerVisible" />
</template>

<script>
import VehicleDetails from "@/components/VehicleDetails";

export default {
  name: "VehicleDetailsView",
  components: {
    VehicleDetails,
  },
  methods: {
    // Funkcja pomocnicza – sprawdza czy jest dostępna historia przeglądarki do cofnięcia
    hasHistory() {
      return window.history.length > 1;
    },
  },
};
</script>

<style scoped>
/* Lewy panel (tło pod filtry) */
.filters-container {
  background: var(--surface-secondary);
}

/* Dostosowanie wysokości wrapa do zawartości */
.content-container .content-wrap,
.content-container > div {
  min-height: auto;
}
</style>
